import React, { useRef }  from 'react'
import Menu from "@material-ui/core/Menu";

/* export default function CustomMenu(props:any) {
  const ref = useRef();
  return (
    <Menu ref={ref} {...props}>
        {props.children}
      </Menu>
  )
} */

const CustomMenu = React.forwardRef((props:any,ref:any)=>{
  return(<Menu ref={ref} {...props}></Menu>)
});

export default CustomMenu;

